import { render, staticRenderFns } from "./BasePlot.vue?vue&type=template&id=059fa05e&scoped=true&"
import script from "./BasePlot.vue?vue&type=script&lang=js&"
export * from "./BasePlot.vue?vue&type=script&lang=js&"
import style0 from "./BasePlot.vue?vue&type=style&index=0&id=059fa05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059fa05e",
  null
  
)

export default component.exports